var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6528 17.9398C41.5903 18.1913 42.3285 18.9323 42.5791 19.8734C43.0344 21.5791 43.0344 25.1378 43.0344 25.1378C43.0344 25.1378 43.0344 28.6965 42.5791 30.4024C42.3285 31.3433 41.5903 32.0844 40.6528 32.336C38.9537 32.793 32.1405 32.793 32.1405 32.793C32.1405 32.793 25.3273 32.793 23.6281 32.336C22.6907 32.0844 21.9524 31.3433 21.7019 30.4024C21.2466 28.6965 21.2466 25.1378 21.2466 25.1378C21.2466 25.1378 21.2466 21.5791 21.7019 19.8734C21.9524 18.9323 22.6907 18.1913 23.6281 17.9398C25.3273 17.4827 32.1405 17.4827 32.1405 17.4827C32.1405 17.4827 38.9537 17.4827 40.6528 17.9398ZM35.6043 25.138L29.9097 28.3689V21.9068L35.6043 25.138Z",
    fill: "#0DD0BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4967",
    x: -6.81956,
    y: -10.5862,
    width: 77.8276,
    height: 77.8276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.82759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4967",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGreen);
export default __webpack_public_path__ + "static/media/youtube-green.d9f3af3af4cff20e181a95fc1ce7c823.svg";
export { ForwardRef as ReactComponent };